import axiosClient from "utils/api";
const URI = "/search";

export const getSearchHistory = async (payload) => {
  const URL = `${URI}/drive`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get search history:", error);
    throw error;
  }
};

export const clearSearchHistory = async (payload) => {
  const URL = `${URI}/drive/delete`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get search history:", error);
    throw error;
  }
};

export const addSearchHistory = async (payload) => {
  const URL = `${URI}/drive`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during add search history:", error);
    throw error;
  }
};